import React, { useEffect } from 'react';
import { Select } from 'antd';
import { PhysicalUnit } from '../../types';

export interface UnitPropsProps {
  units?: PhysicalUnit[];
  disabled: boolean;
  value?: number;
  onChange?: (value: number) => void;
}

const UnitProps: React.FC<UnitPropsProps> = ({ units, disabled, value, onChange }) => {
  useEffect(() => {
    if (!value && units && units.length) {
      onChange && onChange(units[0].id);
    }
  }, [units, value]);

  if (!units || !units.length) return null;
  if (units.length === 1) return <div>{units[0].generalName}</div>;
  return (
    <Select
      style={{ width: 106 }}
      placeholder={'请选择'}
      defaultValue={units[0].id}
      disabled={disabled}
      onChange={onChange}
      value={value}
    >
      {units.map(item => (
        <Select.Option key={item.id} value={item.id}>
          {item.generalName}
        </Select.Option>
      ))}
    </Select>
  );
};

export default UnitProps;
